import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';

const TransactionPieChart = ({ transactions }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // Process transactions into monthly data
  const monthlyData = React.useMemo(() => {
    const data = {};
    
    transactions.forEach((transaction) => {
      const date = new Date(transaction.date);
      const monthYear = date.toLocaleString("default", {
        month: "short",
        year: "2-digit",
      });
      
      if (!data[monthYear]) {
        data[monthYear] = {
          name: monthYear,
          value: 0,
        };
      }
      data[monthYear].value++;
    });
    
    return Object.values(data);
  }, [transactions]);

  // Color palette for the pie chart
  const COLORS = ['#16a34a', '#2563eb', '#7c3aed', '#db2777', '#ea580c', '#84cc16', '#06b6d4'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-2 border rounded shadow">
          <p className="text-sm font-medium">{`${payload[0].name}`}</p>
          <p className="text-sm">{`${payload[0].value} transactions`}</p>
          <p className="text-xs text-gray-500">
            {`${((payload[0].value / transactions.length) * 100).toFixed(1)}% of total`}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <Card style={{ backgroundColor: '#FFFFFF' }}>
      <CardHeader>
        <CardTitle>Monthly Transaction Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[400px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={monthlyData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={150}
                labelLine={false}
                label={({ name, percent }) => 
                  `${name} (${(percent * 100).toFixed(0)}%)`
                }
              >
                {monthlyData.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default TransactionPieChart;